const o = "showMoreButton";
export {
  o as MENU_SHOW_MORE_BUTTON
};
